import constants from "Services/constants"

export const preThemePalette = {
  [constants.ORGANIZATION_PRODUCT_CLOUDERP]: {
    light: {
      background: "#f7f7f7",
      text: "#111827",
      primary: "#0767ab",
      primaryContrast: "#ffffff",
    },
    dark: {
      background: "#121212",
      text: "#e3e7ee",
      primary: "#3885bb",
      primaryContrast: "#ffffff",
    },
  },
  [constants.ORGANIZATION_PRODUCT_PROFITDRIVE]: {
    light: {
      background: "#f7f7f7",
      text: "#111827",
      primary: "#16A34A",
      primaryContrast: "#ffffff",
    },
    dark: {
      background: "#121212",
      text: "#e3e7ee",
      primary: "#22C55E",
      primaryContrast: "#111827",
    },
  },
}

export function getPreThemePalette (
  darkMode,
  product = constants.ORGANIZATION_PRODUCT_CLOUDERP,
) {
  const productPalette = preThemePalette[product] || preThemePalette[constants.ORGANIZATION_PRODUCT_CLOUDERP]
  return darkMode ? productPalette.dark : productPalette.light
}
